import { type FC, type ReactNode, useEffect, useRef } from "react";
import clsx from "clsx";
import { ChevronDown } from "@/components/icons/ChevronDown";

type Props = {
  title: string;
  open: boolean;
  onclick: () => void;
  onClickOutside?: () => void;
  count: number;
  children: ReactNode;
};
export const Collapse: FC<Props> = ({ title, open, children, onclick, onClickOutside, count }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (ref.current && !ref.current.contains(event.target as Node) && open) {
        onClickOutside?.();
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside, open]);

  return (
    <div className="py-5 border-b border-[#E5E5E5]" ref={ref}>
      <div
        className={clsx("flex select-none items-center justify-between cursor-pointer text-sm lg:text-base font-bold")}
        onClick={onclick}
      >
        <div className="flex items-center">
          {title}
          {count !== 0 && (
            <div className="w-6 h-6 bg-primary rounded-full flex justify-center items-center text-white ml-2">
              {count}
            </div>
          )}
        </div>
        <ChevronDown
          className={clsx("w-4 h-4 transition-all text-primary shrink-0", {
            "rotate-0": open,
            "-rotate-90": !open,
          })}
        />
      </div>
      <div
        className={clsx({
          block: open,
          hidden: !open,
        })}
      >
        {children}
      </div>
    </div>
  );
};
